export default [
  {
    header: 'Configuration',
  },
  {
    title: 'Settings',
    route: 'pages-account-setting',
    icon: 'SettingsIcon',
    moduleKey: 'settings',
  },
  {
    title: 'Help',
    route: 'misc-coming-soon',
    icon: 'MessageCircleIcon',
    moduleKey: 'help',
  },
  {
    title: 'Permissions',
    route: 'pages-permissions',
    icon: 'LockIcon',
    roles: {
      consultant: ['read', 'write'],
    },
  },
]
